<template>
	<div class="placeholder">
		<svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M2.71967 2.71967C2.86032 2.57902 3.05109 2.5 3.25 2.5H18.75C18.9489 2.5 19.1397 2.57902 19.2803 2.71967C19.421 2.86032 19.5 3.05109 19.5 3.25V10C19.5 10.3315 19.6317 10.6495 19.8661 10.8839C20.1005 11.1183 20.4185 11.25 20.75 11.25C21.0815 11.25 21.3995 11.1183 21.6339 10.8839C21.8683 10.6495 22 10.3315 22 10V3.25C22 2.8232 21.9159 2.40059 21.7526 2.00628C21.5893 1.61197 21.3499 1.25369 21.0481 0.951903C20.7463 0.650113 20.388 0.410719 19.9937 0.247392C19.5994 0.0840637 19.1768 0 18.75 0H3.25C2.38805 0 1.5614 0.34241 0.951903 0.951903C0.34241 1.5614 0 2.38805 0 3.25V19C0 19.7956 0.31607 20.5587 0.87868 21.1213C1.44129 21.6839 2.20435 22 3 22H11.18C10.58 19.98 11.48 17.52 13.882 16.8C11.316 13.86 7.54 12 3.328 12C3.04933 12 2.77333 12.008 2.5 12.024V3.25C2.5 3.05109 2.57902 2.86032 2.71967 2.71967Z"
				fill="url(#paint0_linear_4419_560)"
			/>
			<path
				d="M10.3787 5.37868C10.9413 4.81607 11.7044 4.5 12.5 4.5C13.2956 4.5 14.0587 4.81607 14.6213 5.37868C15.1839 5.94129 15.5 6.70435 15.5 7.5C15.5 8.29565 15.1839 9.05871 14.6213 9.62132C14.0587 10.1839 13.2956 10.5 12.5 10.5C11.7044 10.5 10.9413 10.1839 10.3787 9.62132C9.81607 9.05871 9.5 8.29565 9.5 7.5C9.5 6.70435 9.81607 5.94129 10.3787 5.37868Z"
				fill="url(#paint1_linear_4419_560)"
			/>
			<path
				d="M19.12 14.8118C19.496 13.0698 21.962 13.0598 22.352 14.7998L22.4 15.0238C22.6245 16.0525 23.1481 16.9919 23.905 17.7239C24.6619 18.4559 25.6183 18.9478 26.654 19.1378C28.448 19.4558 28.448 22.0478 26.654 22.3658C25.6189 22.5559 24.6631 23.0477 23.9066 23.7793C23.1501 24.5108 22.6267 25.4496 22.402 26.4778L22.352 26.7038C21.96 28.4438 19.496 28.4298 19.12 26.6898L19.08 26.4958C18.8649 25.4639 18.3469 24.5196 17.5924 23.7835C16.8378 23.0475 15.8809 22.5532 14.844 22.3638C13.052 22.0458 13.052 19.4578 14.844 19.1398C15.8812 18.9502 16.8383 18.4556 17.5928 17.7192C18.3474 16.9828 18.8652 16.038 19.08 15.0058L19.12 14.8118Z"
				fill="url(#paint2_linear_4419_560)"
				class="placeholder-icon-animation"
			/>
			<defs>
				<linearGradient id="paint0_linear_4419_560" x1="11" y1="0" x2="11" y2="22" gradientUnits="userSpaceOnUse">
					<stop stop-opacity="0.7" />
					<stop offset="1" stop-opacity="0.5" />
				</linearGradient>
				<linearGradient id="paint1_linear_4419_560" x1="11" y1="0" x2="11" y2="22" gradientUnits="userSpaceOnUse">
					<stop stop-opacity="0.7" />
					<stop offset="1" stop-opacity="0.5" />
				</linearGradient>
				<linearGradient
					id="paint2_linear_4419_560"
					x1="20.7497"
					y1="13.5"
					x2="20.7497"
					y2="28.0018"
					gradientUnits="userSpaceOnUse"
				>
					<stop stop-opacity="0.7" />
					<stop offset="1" stop-opacity="0.5" />
				</linearGradient>
			</defs>
		</svg>

		<span class="placeholder-gradient"></span>
	</div>
</template>

<script setup lang="ts"></script>

<style lang="scss" scoped>
.placeholder {
	width: 100%;
	height: 452px;
	background: var(--background-muted);
	position: relative;
	overflow: hidden;
	border-radius: var(--radius-md);
	@include flex-center;
	@if $is-mts {
		opacity: 0.8;
		background:
			linear-gradient(
				137deg,
				rgba(218, 189, 218, 0) 37.18%,
				rgba(218, 189, 218, 0.3) 62.17%,
				rgba(218, 189, 218, 0.5) 69.8%,
				rgba(218, 189, 218, 0) 89.8%
			),
			linear-gradient(136deg, rgba(238, 236, 250, 0.7) 1.59%, rgba(214, 209, 243, 0.7) 100%);
	}
	&-gradient {
		width: 200%;
		height: 200%;
		left: 0;
		top: 0;
		display: block;
		position: absolute;
		background: linear-gradient(
			137.168deg,
			transparent 37%,
			color-mix(in srgb, var(--text-brand) 14%, transparent) 63%,
			color-mix(in srgb, var(--text-brand) 15%, transparent) 69%,
			transparent 77%
		);
		animation: fullDiagonal 5s linear infinite;
	}
	// цвет градиентов иконки — фирменный тенанта (в SVG-атрибуте var() не работает)
	stop {
		stop-color: var(--text-brand);
	}
	&-icon-animation {
		transform-origin: 19.7px 20.6px;
		animation: spinAndMove 3s linear infinite;
	}
}

@keyframes fullDiagonal {
	0% {
		transform: translateX(-100%) translateY(-100%);
	}
	100% {
		transform: translateX(6%) translateY(6%);
	}
}

@keyframes iconAnimation {
	0% {
		transform: scale(1) rotate(0);
	}
	40% {
		transform: scale(1) rotate(0);
	}
	50% {
		transform: scale(1) rotate(180);
	}
	100% {
		transform: scale(0);
	}
}

@keyframes spinAndMove {
	0% {
		transform: translate(0, 0) scale(1) rotate(0deg);
	}
	15% {
		transform: translate(0, 0) scale(1) rotate(0deg);
	}
	80% {
		transform: translate(8px, -13px) scale(0.1) rotate(180deg);
	}
	100% {
		transform: translate(0, 0) scale(1) rotate(0deg);
	}
}
</style>
